export default function addWindowOnBeforeUnloadCallback(component, handleViewUnload) {
  if (!component.subscriptions) {
    throw new Error("component.subscriptions property is missing");
  }

  window.onbeforeunload = handleViewUnload;
  const clearWindowOnBeforeUnload = () => {
    if (window.onbeforeunload === handleViewUnload) {
      delete window.onbeforeunload;
    }
  };
  component.subscriptions.push({ unsubscribe: clearWindowOnBeforeUnload });

  if (!component.props.routes || !component.props.router) {
    throw new Error("component.routes or component.router properties are missing");
  } else {
    const route = component.props.routes[component.props.routes.length - 1];
    const removeRouteLeaveHook = component.props.router.setRouteLeaveHook(route, handleViewUnload);
    component.subscriptions.push({ unsubscribe: removeRouteLeaveHook });
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/addWindowOnBeforeUnloadCallback.js